export function checkMeta(name: string) {
    return (entity: any) => {
        if (entity.meta === undefined) {
            return false
        }

        if (entity.meta[name] === undefined) {
            return false
        }

        return entity.meta[name]
    }
}

export const isNew = checkMeta('new')
export const isDeleted = checkMeta('delete')
export const isUpdated = checkMeta('updated')
export const isSoftDelted = checkMeta('softDeleted')
